import Component from '@glimmer/component';
import { action } from '@ember/object';
import * as monaco from 'monaco-editor/editor/editor.api';

window.MonacoEnvironment = {
  getWorker() {
    const blob = new Blob(['self.onmessage = function() {};'], {
      type: 'application/javascript',
    });
    return new Worker(URL.createObjectURL(blob));
  },
};

export default class ScansYamlEditorComponent extends Component {
  editor = null;

  @action
  setupEditor(element) {
    this.editor = monaco.editor.create(element, {
      value: this.args.value ?? '',
      language: 'yaml',
      theme: 'vs',
      minimap: { enabled: false },
      scrollBeyondLastLine: false,
      fontSize: 13,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      lineNumbers: 'on',
      renderLineHighlight: 'gutter',
      padding: { top: 12, bottom: 12 },
      readOnly: this.args.readOnly ?? false,
    });
  }

  @action
  updateEditorOptions(_, __, options) {
    if (this.editor) this.editor.updateOptions(options);
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.editor?.dispose();
    this.editor = null;
  }

  @action
  submitReview() {
    const value = this.editor?.getValue();
    this.args.onSubmit?.(value);
  }
}
